import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TabsModule } from '../../../tabs/tabs.module';
import { ArticleCardComponent } from '../article-card/article-card.component';
import { KnowledgeCentreCard } from './models/knowledge-centre-card.model';

@Component({
    selector: 'nw-knowledge-centre-block',
    imports: [TabsModule, ArticleCardComponent],
    templateUrl: './knowledge-centre-block.component.html',
    styleUrl: './knowledge-centre-block.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class KnowledgeCentreBlockComponent {
    @Input() tabs: string[] = [];
    @Input() cards!: Record<string, KnowledgeCentreCard[]>;

    public readonly colors: string[] = [
        '#050299',
        '#C22A98',
        '#5100D4',
        '#6EB6AB',
        '#A81208',
        '#528FF0',
        '#1843D2',
        '#92CF59'
    ];
}
